module.exports = __webpack_public_path__ + "img/PPTX_document_icon@2x.aaaf3738.png";